import React from 'react'
import { useParams, Redirect } from 'react-router-dom'

import { useFeatureFlag } from 'components/ff4j'
import { cardFlags } from 'constants/card-flags'
import StringFormat from 'utils/StringFormat'

const CheckRoutes = ({ children }) => {
    const { bank, product } = useParams()
    const enabled = useFeatureFlag(
        cardFlags[StringFormat.productRoutesToProductCode(product)]
    )

    if (enabled) return <>{children}</>

    if (bank) return <Redirect to={`/${bank}`} />

    return <Redirect to="/" />
}

export default CheckRoutes
